import type { ForecastRun } from '../types'

export default function FinalPredictionCard({ run, embedded = false }: { run: ForecastRun; embedded?: boolean }) {
  const fr = run.final_result
  if (!fr) return null

  const probPct = typeof fr.probability === 'number' ? fr.probability * 100 : null
  const confidence = (fr.confidence || '').toString().toUpperCase()
  const ciLow = typeof fr.confidence_interval_90_low === 'number' ? fr.confidence_interval_90_low : null
  const ciHigh = typeof fr.confidence_interval_90_high === 'number' ? fr.confidence_interval_90_high : null

  const pct = (v: number) => `${(v * 100).toFixed(0)}%`

  const getConfidenceColor = () => {
    const conf = confidence.toLowerCase()
    if (conf === 'high') return '#2f6b3d' // Green
    if (conf === 'medium') return '#b8924a' // Gold
    if (conf === 'low') return '#a84848' // Clay Red
    return '#6b5b7f' // Dusty Purple (default)
  }

  const content = (
    <>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs text-muted tracking-wider font-semibold">FINAL</div>
          <div className="font-serif text-5xl sm:text-6xl leading-none text-ink mt-2">
            {probPct != null ? `${probPct.toFixed(1)}%` : '--'}
          </div>
          <div 
            className="text-xs font-semibold tracking-wider mt-2 inline-block px-2 py-1 rounded"
            style={{
              color: confidence ? getConfidenceColor() : 'var(--muted)',
              backgroundColor: confidence ? `${getConfidenceColor()}15` : 'transparent'
            }}
          >
            {confidence ? `${confidence} CONFIDENCE` : 'CONFIDENCE --'}
          </div>
          {ciLow != null && ciHigh != null && (
            <div className="mt-2 text-xs text-muted">
              90% CI: <span className="text-ink">{pct(ciLow)}</span> – <span className="text-ink">{pct(ciHigh)}</span>
            </div>
          )}
        </div>
        <div className="font-mono text-[11px] text-muted">
          {run.completed_at ? new Date(run.completed_at).toLocaleString() : new Date(run.created_at).toLocaleString()}
        </div>
      </div>
    </>
  )

  if (embedded) {
    return <div role="region" aria-label="Final prediction">{content}</div>
  }

  return (
    <section
      className="rounded-delphi border border-rule bg-paper2 shadow-delphi p-4 sm:p-5"
      role="region"
      aria-label="Final prediction"
    >
      {content}
    </section>
  )
}



